import React from 'react';
import { Link } from 'react-router-dom';
import { useStoreConfigContext } from '/src/providers';
import * as styles from './styles.scss';

const Left = () => {
    const {
        storeConfig: {
            header_logo_src,
            logo_alt,
            header_mobile_logo_src,
        }
    } = useStoreConfigContext();

    return (
        <>
            <Link
                className={styles.logo}
                to="/"
            >
                <img src={header_logo_src} alt={logo_alt} />
            </Link>
            <Link
                className={styles.mobile}
                to="/"
            >
                <img src={`${header_mobile_logo_src}?d=80x60`} alt={logo_alt} />
            </Link>
        </>
    );
};

export default Left;
